import React from 'react';

const VedantaHighlightsColThree = () => {
  return (
    <div className="highlights-col">
      <h5>~INR 32,400 Crore</h5>
      <p>Total contribution to the national exchequer</p>

      <h5>Largest </h5>
      <p>Natural resources company in India</p>

      <h5>9 million + tCO2e</h5>
      <p>
        in avoided emissions, over the last eight years, as a result of our Greenhouse Gas (GHG) reduction programme
      </p>
    </div>
  );
};

export default VedantaHighlightsColThree;
